import React, { useEffect, useState } from 'react';
import { useConfig } from 'app/config.ctx';
import logo from '../assets/oecd-logo-bg.png';

export const addDotsEllipsis = (str, wordsToShow = 10) => {
  const words = str.split(' ');

  if (words.length > wordsToShow) {
    const truncatedWords = words.slice(0, wordsToShow);
    return truncatedWords.join(' ') + '...';
  }

  return str;
}


export const ImageThumb = (props) => {
  const { styles, src } = props;
  const { BASE_URL } = useConfig();
  const [imgSrc, setImgSrc] = useState(null);
  const [isErrorPlaceholder, setIsErrorPlaceholder] = useState(null);

  const logoStyles = { width: '100%' };

  useEffect(() => {
    setImgSrc(`${BASE_URL}${src}`)
  }, [BASE_URL]);

  return (
    <img
      src={imgSrc || logo}
      onError={() => {
        setImgSrc(logo);
        setIsErrorPlaceholder(true);
      }}
      style={isErrorPlaceholder ? logoStyles : styles}
    />
  )
}

export const joinURL = (...args) =>
  args
    .join('/')
    .replace(/[\/]+/g, '/')
    .replace(/^(.+):\//, '$1://')
    .replace(/^file:/, 'file:/')
    .replace(/\/(\?|&|#[^!])/g, '$1')
    .replace(/\?/g, '&')
    .replace('&', '?');